import { ORDER_STATUS, WIZARD_STEP, AUDIENCE_MODE } from './constants';

/**
 * Maps an existing order status to the wizard step the member should resume at.
 * Returns null when the order can no longer be edited in the wizard.
 */
export const getWizardStepForOrder = (order) => {
  switch (order?.status) {
    case ORDER_STATUS.DRAFT:
      return WIZARD_STEP.AUDIENCE;
    case ORDER_STATUS.RESOLVING:
    case ORDER_STATUS.RESOLUTION_FAILED:
      return WIZARD_STEP.RESOLUTION;
    case ORDER_STATUS.REVIEW:
      return WIZARD_STEP.REVIEW;
    // An interrupted pay resumes on the Pay step in a processing state; the
    // wizard polls until the debit settles (→ PAID) or unlocks (→ REVIEW).
    case ORDER_STATUS.PAYING:
      return WIZARD_STEP.PAY;
    default:
      return null;
  }
};

export const parseTagsInput = (value = '') =>
  value
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean);

export const buildAudienceCriteria = (mode, tagsInput) => {
  if (mode === AUDIENCE_MODE.TAGS) {
    return { mode, tags: parseTagsInput(tagsInput) };
  }

  return { mode: AUDIENCE_MODE.ALL };
};

export const isSameAudienceCriteria = (a, b) => {
  if (!a || !b) return false;
  if (a.mode !== b.mode) return false;
  if (a.mode === AUDIENCE_MODE.ALL) return true;

  const tagsA = [...(a.tags || [])].sort();
  const tagsB = [...(b.tags || [])].sort();

  return tagsA.length === tagsB.length && tagsA.every((tag, index) => tag === tagsB[index]);
};

// A draft may only be reused when it references the SAME asset; otherwise a
// member who went Back and picked a different asset would silently pay for
// the original one.
export const isSameAsset = (a, b) => {
  if (!a || !b) return false;

  return a.kind === b.kind && a.sourceId === b.sourceId;
};

export const formatDate = (value) => {
  if (!value) return '';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatCredits = (value) => {
  const numeric = Number(value || 0);

  return numeric.toLocaleString('en-US');
};
